import { z } from "zod";
export const npdSettingsDtoSchema = z.object({
    temperature: z.number(),
});
